/**
 * @file track.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _utilsBrowserJs = require('../utils/browser.js');

var browser = _interopRequireWildcard(_utilsBrowserJs);

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

var _utilsGuidJs = require('../utils/guid.js');

var Guid = _interopRequireWildcard(_utilsGuidJs);

var _eventTarget = require('../event-target');

var _eventTarget2 = _interopRequireDefault(_eventTarget);

/**
 * setup the common parts of an audio, video, or text track
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html
 *
 * @param {String} type The type of track we are dealing with audio|video|text
 * @param {Object=} options Object of option names and values
 * @extends EventTarget
 * @class Track
 */

var Track = (function (_EventTarget) {
  _inherits(Track, _EventTarget);

  function Track() {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, Track);

    _EventTarget.call(this);

    var track = this;
    if (browser.IS_IE8) {
      track = _globalDocument2['default'].createElement('custom');
      for (var prop in Track.prototype) {
        if (prop !== 'constructor') {
          track[prop] = Track.prototype[prop];
        }
      }
    }

    var trackProps = {
      id: options.id || 'vjs_track_' + Guid.newGUID(),
      kind: options.kind || '',
      label: options.label || '',
      language: options.language || ''
    };

    var _loop = function (key) {
      Object.defineProperty(track, key, {
        get: function get() {
          return trackProps[key];
        },
        set: function set() {}
      });
    };

    for (var key in trackProps) {
      _loop(key);
    }

    return track;
  }

  return Track;
})(_eventTarget2['default']);

exports['default'] = Track;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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